import React from 'react'

const GuessWordContext = React.createContext();

export default GuessWordContext;